/**
 * 📌 作用：
 *
 * 作用类似于 Vue 组件中的 computed 计算属性
 * 用来对 state 进行计算、过滤、拼接
 * 不会修改 state，只是用于获取数据
 * ✅ 如何使用 getters？
 * computed: {
 *   userId() {
 *     return this.$store.getters.getUserId;
 *   },
 * }
 */
export default {
  //新增或者已整理的
  getUserId(state) {
    return state.userId || Number(localStorage.getItem('userId')) || 0;
  },

  //未整理的

  // nfcReadTxt(state) {
  //   return state.nfcReadTxt
  // },
  // nfcWriteTxt: state => {
  //   return state.nfcWriteTxt
  // },
  getShowPublish(state) {
    return state.showPublish
  },
  getIsCart(state) {
    return state.isCart
  },
  getOrderObj(state) {
    return state.orderStateObj
  },
  getTalkbaoIndex(state) {
    return state.talkbaoindex
  },
  getGuangguangIndex(state) {
    return state.guangguangindex
  },
  getImprintIndex(state) {
    return state.imprintindex
  },
  getShowUpdateNum(state) {
    return state.showUpdateNum
  },
  getFocusAddRemark(state) {
    return state.focusAddRemark
  },
  getUserInfo(state) {
    if (!state) {
      let localUser = localStorage.getItem('userinfo')
      if (localUser) {
        return localUser
      }
    }
    return state
  },

  getBoothStoreDetail(state) {
    return state.boothStoreDetail
  },
  getOrderKeyId(state) {
    return state.orderKeyId
  },
  getIGetSalesNum(state) {
    return state.iGetSalesNum
  },
  getIGetUpdateSalesNum(state) {
    return state.iGetUpdateSalesNum
  },
  getBmTab(state) {
    return state.bmTab
  },
  getBackWaitOrder(state) {
    return state.backWaitOrder
  },
  getAddRemarkText(state) {
    return state.addRemarkText
  },
  getAddRemarkObj(state) {
    return state.addRemarkObj
  },
  getVideoShow(state) {
    return state.videoShow
  },
  getVideoSrc(state) {
    return state.videoSrc
  },
  getHomePop(state) {
    return state.homePop
  },
  nfcReadtxt: state => {
    return state.nfcReadTxt
  },
  nfcWriteTxt: state => {
    return state.nfcWriteTxt
  },

  nfcWriteLog: state => {
    return state.nfcWriteLog
  },
  // getNum(state){
  //   state.swiperNum = JSON.parse(localStorage.getItem('swiperNum'))
  //   console.log('113231',state.swiperNum);
  //   return state.swiperNum
  // }

  //NFC
  readMode: (state) => state.readMode,
  writeMode: (state) => state.writeMode,
  isProcessing: (state) => state.isProcessing,
  multipleWrite: (state) => state.multipleWrite,
  getResourceId: (state) => state.resourceId,
  getRedirectTo: (state) => state.redirectTo,
}



// WEBPACK FOOTER //
// ./src/store/getters.js